import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/nosotros', label: 'Nosotros' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/contacto', label: 'Contacto' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://static.readdy.ai/image/602524d9e3f59449eddce061e2bb9ef5/85673504354e4797007d75e7801a20cd.png"
              alt="Kronos Consultoría Contable"
              className="h-12 w-auto"
            />
            <span className={`font-heading font-bold text-lg transition-colors ${isScrolled ? 'text-primary' : 'text-white'}`}>
              Kronos Consultoría
            </span>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-body text-sm font-semibold transition-colors hover:text-gold ${
                  location.pathname === link.path
                    ? isScrolled
                      ? 'text-gold'
                      : 'text-gold'
                    : isScrolled
                    ? 'text-gray-700'
                    : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+525614025070"
              className={`flex items-center space-x-2 font-body text-sm font-semibold transition-colors ${
                isScrolled ? 'text-primary' : 'text-white'
              }`}
            >
              <i className="ri-phone-line"></i>
              <span>56 1402 5070</span>
            </a>
          </nav>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isScrolled ? 'text-primary' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <nav className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block font-body text-base font-semibold transition-colors hover:text-gold ${
                  location.pathname === link.path ? 'text-gold' : 'text-gray-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+525614025070"
              className="flex items-center space-x-2 font-body text-base font-semibold text-primary"
            >
              <i className="ri-phone-line"></i>
              <span>56 1402 5070</span>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;